module.exports = __webpack_public_path__ + "static/media/image_4.d37b2350.jpg";